export const APP_VERSION = "local-dev-1771524645564"; // change on every deploy
